import { css } from '@/styled-system/css';

export const panelOutlet = css({
  position: 'absolute',

  inset: 0,
  zIndex: 'zIndexOverParent',
  backgroundColor: 'bg.neutral',
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  willChange: 'transform',
  transitionProperty: 'transform',
  transitionDuration: '300ms',
  transitionTimingFunction: 'ease-out',
});

export const panelOutletHidden = css({
  transform: 'translateX(100%)',
  pointerEvents: 'none',
});

export const panelOutletVisible = css({
  transform: 'translateX(0)',
});

export const panelHeader = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  minHeight: '1200',

  flexShrink: 0,
  paddingInline: 'looser',
  paddingBlock: 'default',
  position: 'sticky',

  top: 0,
  background: 'bg.neutral',
  zIndex: 'zIndexParent',
  borderBottomWidth: 'default',
  borderBottomStyle: 'solid',
  borderBottomColor: 'border.neutral',
  container: 'hdpDesktopHeader / inline-size',
});

export const panelHeaderColumns = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  gap: 'default',
});

export const panelHeaderLeft = css({
  display: 'flex',
  alignItems: 'center',
  gap: '200',

  minWidth: 0,
});

export const panelHeaderRight = css({
  display: 'flex',
  gap: 'default',
  alignItems: 'center',

  flexShrink: 0,
});

export const panelHeaderTitle = css({
  fontSize: 'body',
  fontWeight: 'bold',
  lineHeight: 'body',
  color: 'text.neutral',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',

  margin: 0,
});

export const panelHeaderSubtitle = css({
  fontSize: 'body-xs',
  color: 'text.subtle',

  margin: 0,
  lineHeight: 'body-xs',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const panelBackButton = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'tightest',
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  color: 'text.neutral',
  fontSize: 'body-sm',
  fontWeight: 'bold',
  fontFamily: 'inherit',
  padding: 'tighter',
  borderRadius: 'sm',
  _hover: {
    background: 'bg.softest',
  },
  _focusVisible: {
    outlineWidth: 'thick',
    outlineStyle: 'solid',
    outlineColor: 'brand.primary',
    outlineOffset: '50',
  },
});

export const panelBody = css({
  flex: 1,
  paddingInline: 'looser',
  paddingBlock: 'default',
});
